import { primary, secondary, fontFamily } from '../App/theme';

export const BubbleOptionStyle = {
  background: secondary.main,
  color: '#fff',
  fontFamily: fontFamily
}

export const StyledChat = {
  background: '#F8F8F8',
  fontFamily: fontFamily,
  headerBgColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: '#fff',
  botFontColor: primary.main,
  userBubbleColor: secondary.main,
  userFontColor: '#fff'
};